import React from 'react';
import className from 'classnames';
import { connect } from 'react-redux';
import { AgGridReact } from '@ag-grid-community/react';
import { AllCommunityModules } from '@ag-grid-community/all-modules';
import '../../assets/styles/components/data-table.scss';
import Header from './Header';
import CustomRenderer from './CustomRenderer';
import CustomNoRow from './CustomNoRow';
import CustomLoadingOverlay from './CustomLoadingOverlay';
import { BROWSER, LANG_KEY } from '../../constants/app';
import { detectBrowsers, getInitState, getSafe } from '../../helpers/global';
import GridFooter from './Footer';
import { utilsFunction, Converter } from '@/helpers/functions';
import { userActions } from '@/actions/user';

const initStateFunc = getInitState({
  TTLShowPagination: false,
  FUBONShowPagination: false
})

class DataTable extends React.Component {
  static getDerivedStateFromProps(nProps, prevState) {
    if (nProps.data || nProps.columnDefs) {
      return {
        columnDefs: nProps.columnDefs,
        rowData: nProps.data
      }
    }
    return null
  }

  constructor(props) {
    super(props)
    this.state = {
      modules: AllCommunityModules,
      columnDefs: [],
      paginationPageSize: 10,
      defaultColDef: {
        flex: 1,
        minWidth: 120,
        cellStyle: {},
        headerClass: 'app-table-header',
        editable: false,
        resizable: true,
        sortable: true,
        cellClass: 'align-right',
        cellRenderer: 'customRenderer',
        unSortIcon: true
      },
      rowStyle: {
        rowHeight: 30
      },
      scrollbarWidth: 8,
      rowData: null,
      getRowStyle: lastRowBorder,
      frameworkComponents: {
        customRenderer: CustomRenderer,
        customLoadingOverlay: CustomLoadingOverlay,
        customNoRowsOverlay: CustomNoRow,
      },
      tooltipShowDelay: 0,
      fireGridApi: null,
      renderColumnDefs: this.renderColumnDefs.bind(this),
      noRowsOverlayComponent: 'customNoRowsOverlay',
      loadingOverlayComponent: 'customLoadingOverlay',
      loadingOverlayComponentParams: { loadingMessage: 'common_msg_loading' },
      animateRows: false,
      suppressDragLeaveHidesColumns: true
    }
    this.tableName = props.name
    this.columnPreference = props.columnDefs.map(v => ({ colId: v.colId }))
    this.updateDimensions = this.updateDimensions.bind(this);
    props.innerRef(this)
  }

  renderColumnDefs(columnDefs) {
    this.setState({
      columnDefs: columnDefs.map(v => (v.headerTooltip = v.headerName ? v.headerName : '-') && v)
    }, () => {
      this.updateDimensions();
      // this.columnPreference.map(i => {
      //   columnDefs.forEach(h => {
      //     if (i.colId === h.colId) {
      //       i.hide = h.hide
      //     }
      //   })
      
    })
    // if (this.tableName) {
    //   this.props.updateUserPreferences({ [this.tableName]: this.columnPreference }, res => {})
    // }
    // })
  }


  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setRowData(this.props.data);
    this.gridApi.sizeColumnsToFit();
    if (!this.props.autoSizeColumns) {
    }
    this.setState({ fireGridApi: this.gridApi })
    this.handlePreferencesCloumn()
    // if (window !== 'undefined') {
    //   window.addEventListener('resize', this.updateDimensions, false);
    // }
  };

  onFirstDataRendered = (params) => {
    if (this.props.autoSizeColumns) {
      params.columnApi.autoSizeColumns(false, true);
      // this.gridApi.sizeColumnsToFit();
    }
    // this.gridApi.sizeColumnsToFit();
  }

  componentDidMount() {
    const { columnDefs } = this.props;
    const browser = detectBrowsers()

    if (browser === BROWSER.CHROME) this.setState({ animateRows: true });
    columnDefs.map(col => {
      return { ...col }
    })
    // if (browser !== BROWSER.FIREFOX) this.setState({ scrollbarWidth: 4 });
    this.renderColumnDefs(columnDefs);
  }

  componentWillUnmount() {
    // window.removeEventListener('resize', this.updateDimensions, false);
  }

  updateDimensions = () => {
    if (!this.state.fireGridApi) return;
    if (!this.props.autoSizeColumns) {
      this.gridApi.sizeColumnsToFit();
    }
  }

  updateHeaderLanguage = () => {
    const { columnDefs } = this.state;
    if(!this.gridApi) return
    columnDefs.forEach(col => {
      let text = this.props.language[col.colId];
      col.headerName = text ? text : col.headerName;
      col.headerTooltip = col.headerName
      if (col.children) {
        let children = col.children;
        children.forEach(child => {
          let childText = this.props.language[child.colId];
          child.headerName = childText ? childText : child.headerName;
        })
      }
    });
    this.gridApi.setColumnDefs(columnDefs)
  }

  componentDidUpdate(prevProps) {
    const { preference } = this.props
    if (prevProps.language !== this.props.language) {
      this.updateHeaderLanguage();
      if (this.props.autoSizeColumns && this.gridColumnApi) {
        var allColumnIds = [];
        this.gridColumnApi.getAllColumns().forEach(function (column) {
          allColumnIds.push(column.colId);
        });
        this.gridColumnApi.autoSizeColumns(allColumnIds, false);
      }
    }

    if (preference && (JSON.stringify(prevProps.preference) !== JSON.stringify(preference) || prevProps.language !== this.props.language)) {
      this.handlePreferencesCloumn()
    }
  }

  toggleLoadingOverlay = utilsFunction.debounce((bool) => {
    if (this.gridApi) {
      if (bool) {
        this.gridApi.showLoadingOverlay();
      } else {
        if (Array.isArray(this.props.data) && this.props.data.length == 0) {
          this.gridApi.showNoRowsOverlay();
        } else {
          this.gridApi.hideOverlay();
        }
      }
    }
  }, 100)

  handlePreferencesCloumn = () => {
    const { preference, language , columnDefs} = this.props

    if (this.gridApi) {
      const gridColumns = this.gridApi.columnController.gridColumns
      const gridColumnsMap = gridColumns.reduce((prev, next) => {
        return (prev[next.userProvidedColDef.colId] = next, prev)
      }, {})
  
      const currentLanguagePreference = preference[Converter.mappingWinVestLanguage(language.lang)]
      if (typeof currentLanguagePreference === 'object' && currentLanguagePreference[this.tableName]) {
        const preferenceParse = getSafe(() => JSON.parse(currentLanguagePreference[this.tableName]), [])
        const preferenceColumnWidth = preferenceParse.map(item => {
          if (item.width) {
            return { key: gridColumnsMap[item.colId], newWidth: item.width }
          }
        }).filter(Boolean)
        columnDefs.map(h => {
          if (h.hide !== "") {
            preferenceParse.forEach(i => {
              if (i.colId === h.colId) {
                h.hide = i.hide
              }
            })
          }
        })
        this.gridApi.setColumnDefs(columnDefs)
        this.columnPreference = Array.isArray(preferenceParse) && preferenceParse.length ? preferenceParse : this.columnPreference
        this.gridApi.columnController.columnApi.setColumnWidths(preferenceColumnWidth)
      } else {
        this.columnPreference = this.columnPreference.map(v => ({ colId: v.colId }))
        this.gridApi.sizeColumnsToFit()
      }
    }
  }

  onDragStopped = (event) => {
    const colId = event.target.parentElement.getAttribute('col-id')
    const clientWidth = event.target.parentElement.clientWidth
    this.columnPreference = this.columnPreference.map(item => {
      if (item.colId === colId) {
        item['width'] = clientWidth
      }
      return item
    })
    if (this.tableName) {
      this.props.updateUserPreferences({ [this.tableName]: this.columnPreference }, res => {})
    }
  }

  reCreateGrid() {
    let newState = {
      ...this.state,
      isDestroyed: false,
    };
    this.setState(newState);
    const { columnDefs } = this.props;
    columnDefs.map(col => {
      return { ...col }
    })
    this.renderColumnDefs(columnDefs);
    this.gridApi.setAutoGroupColumnDef(columnDefs)
  }

  onPageChanged(page) {
    if (this.gridApi) {
      if (page === 0) {
        this.gridApi.paginationGoToFirstPage();
      } else if (page === this.props.data.length) {
        this.gridApi.paginationGoToLastPage();
      } else {
        this.gridApi.paginationGoToPage(page - 1);
      }
    }
  }
  getSelect(){
    return this.gridApi.getSelectedRows()
  }

  render() {
    const { language, theme, ...props } = this.props;
    const { rowData, tooltipShowDelay, scrollbarWidth } = this.state;

    return (
      <div className="table-wrapper">
        {props.showHeader && <Header {...props} />}
        <div id="app-grid" className={className("ag-theme-custom-" + theme)}>
          <AgGridReact
            rowSelection={'multiple'}
            gridOptions={this.state.rowStyle}
            modules={this.state.modules}
            columnDefs={this.state.columnDefs}
            defaultColDef={this.state.defaultColDef}
            rowData={rowData}
            onGridReady={this.onGridReady}
            onFirstDataRendered={this.onFirstDataRendered}
            onDragStopped={this.onDragStopped}
            rowHeight={26}
            // colResizeDefault={"shift"}
            animateRows={true}
            pagination={this.props.showPagination}
            suppressPaginationPanel={true}
            paginationPageSize={this.state.paginationPageSize}
            frameworkComponents={this.state.frameworkComponents}
            loadingOverlayComponent={this.state.loadingOverlayComponent}
            loadingOverlayComponentParams={
              this.state.loadingOverlayComponentParams
            }
            noRowsOverlayComponent={this.state.noRowsOverlayComponent}
            enableCellTextSelection
            debounceVerticalScrollbar={true}
            tooltipMouseTrack={true}
            tooltipShowDelay={tooltipShowDelay}
            suppressDragLeaveHidesColumns={this.state.suppressDragLeaveHidesColumns}
            scrollbarWidth={scrollbarWidth}
          />
        </div>
        {
          this.props.showPagination && <GridFooter
            data={this.props.data ? this.props.data : 0}
            onPageChanged={(page) => this.onPageChanged(page)}
            paginationPageSize={this.state.paginationPageSize}
          />
        }

      </div>
    )
  }
}

DataTable.defaultProps = {
  showHeader: false,
  showPagination: Boolean(initStateFunc('TTLShowPagination', null, true)),
  innerRef: () => { },
  autoSizeColumns: false
}

export default connect(
  state => ({
    language: state.app.language,
    theme: state.app.theme,
    preference: state.user.preference,
  }),
  dispatch => ({
    updateUserPreferences: (p, c) => dispatch(userActions.updateUserPreferencesAction(p, c))
  })
)(DataTable)

function lastRowBorder(params) {
  if (params.node.rowIndex == params.api.rowModel.rowsToDisplay.length - 1) {
    return { borderBottom: 'thick green' }
  }
  else {
    return {}
  }
}